import Loading from '@/components/common/Loading'
import dynamic from 'next/dynamic'
import Head from 'next/head'
import SchemaTags from "@/components/common/SchemaTags";
import React from 'react'



const Desktop = dynamic(() => import("@/components/outlet/HomeLivingDesktop"), {
  loading: () => <Loading />
})

const Mobile = dynamic(() => import("@/components/outlet/HomeLivingMobile"), {
  loading: () => <Loading />
})


const HomeLiving = ({mobileView}) => {
    return(
        <>
        <Head>
                <title>Home & Living POS Software | Smart Retail Billing & CRM</title>
                <link rel="canonical" href="https://queuebuster.co/outlet/home-living-pos-billing-software" />
                <link rel="alternate" href="https://queuebuster.co/outlet/home-living-pos-billing-software" hrefLang="en" />
                <meta name="description" content="Manage billing, inventory & customer loyalty with QueueBuster’s POS software for home & living. Ideal for furniture, home decor & lifestyle stores."/>
                <meta property="og:title" content="QueueBuster POS for Home & Living – Smart Billing & Inventory for Lifestyle Retailers" /> 
                <meta property="og:description" content="QueueBuster POS software is designed for home & living. From furniture shops to home décor, manage sales, stock, and CRM in one place. Run smarter operations with fast billing, real-time inventory, and loyalty tools." />
                <meta property="og:image" content="" />
                <meta property="og:url" content="https://queuebuster.co/outlet/home-living-pos-billing-software" />
            </Head>
         <SchemaTags page="home-living-pos-billing-software" />
          {mobileView ?  <Mobile/>: <Desktop/>}
        </>
    )
}


export default HomeLiving